import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardMedia, Grid } from '@mui/material';
import { useData } from '../../../contexts';
import { MdClose, MdHelpOutline } from 'react-icons/md';
import { Tooltip, TooltipTrigger, TooltipContent } from '../../Tooltip/Tooltip';
import { SelectionPanel } from '../InsightsSynthesisSelectionPanel/SelectionMenuComponents/SelectionPanel';
import { MapVlaanderenInsights } from '../../Map/Map';
import { InfoPanelCluster } from '../../InfoPanelCluster/InfoPanelCluster';

export const InsightsClusterMobile = (props: any) => {
  const {
    pathInteractieveTool,
    toggled,
    open,
    setOpen,
    themas,
    indicatorThema,
    gemeenteLijst,
    benchmarkLijst,
    setBenchmarkLijst,
    d_ruimte,
    d_cluster,
    f_clusters,
    d_thema,
    clusterAnalysePath,
    mobile,
  } = props;

  const {
    selectedGemeente,
    selectedTopic,
    setSelectedTopic,
    selectedBenchmarks,
    interfaceColor,
    locale,
  } = useData();

  const id = 'insightsCluster';

  const colors = [
    '#005f73',
    '#0a9396',
    '#94d2bd',
    '#ee9b00',
    '#ca6702',
    '#5977B1',
    '#ae2012',
    '#9b2226',
    '#e9d8a6',
    '#fff',
  ];

  const clusterAlles = [
    {
      id: -1,
      clusterDescShort: 'Alle clusters',
      clusterDesc:
        'Alle clusters samen in beeld gebracht. Kies hierboven een specifieke cluster voor meer detail.',
    },
  ];

  const [selectedCluster, setSelectedCluster] = useState(-1);
  const [dataGemeente, setDataGemeente] = useState({
    id: 0,
    clusterDescShort: 'niet van toepassing',
    clusterDesc: 'niet van toepassing',
  });
  const [dataBenchmark, setDataBenchmark] = useState({
    id: 0,
    clusterDescShort: 'niet van toepassing',
    clusterDesc: 'niet van toepassing',
  });

  const [dataCluster, setDataCluster] = useState([
    {
      id: 11002,
      ruimte: 'Antwerpen',
      idCluster: 3,
      clusterDescShort: 'Cluster 3',
    },
  ]);
  const [dataClusterDesc, setDataClusterDesc] = useState([
    {
      id: 1,
      clusterDescShort: 'Cluster 1',
      clusterDesc:
        'Lage waarden rond de verschillende armoede-indicatoren, maar de gemeenten kennen een relatief hoog gemiddeld inkomen',
    },
  ]);

  const handleOpen = () => setOpen(true);

  useEffect(() => {
    toggled && handleOpen();
  }, [toggled]);

  useEffect(() => {
    if (d_thema && d_cluster) {
      setSelectedTopic(d_thema.find((d: any) => d.thema === 'Armoede'));
    }
  }, [d_thema, d_cluster]);

  useEffect(() => {
    if (d_ruimte && d_cluster && f_clusters) {
      if (selectedTopic.id !== 0) {
        const d_cluster_topic = d_cluster.filter((d: any) => {
          return parseInt(d.idThema) === parseInt(selectedTopic.id);
        });

        const f_clusters_topic = f_clusters.filter((d: any) => {
          return parseInt(d.idThema) === parseInt(selectedTopic.id);
        });

        const unique = [
          ...new Set(f_clusters_topic.map((d: any) => d.idCluster)),
        ];

        // unique.sort(function (a: any, b: any) {
        //   return a - b;
        // });

        f_clusters_topic.map((d: any) => {
          const gemeente = d_ruimte.find(
            (a: any) => parseInt(a.id) === parseInt(d.idRuimte),
          );
          const cluster = d_cluster_topic.find(
            (a: any) => parseInt(a.id) === parseInt(d.idCluster),
          );

          const clusterIndex = unique.findIndex(
            (a: any) => parseInt(a) === parseInt(d.idCluster),
          );

          d.color = colors[clusterIndex];
          d.clusterDescShort = cluster.clusterDescShort;
          d.ruimte = gemeente.ruimte;
          return d;
        });

        f_clusters_topic.sort((a: any, b: any) => {
          let fa = a.clusterDescShort.toLowerCase(),
            fb = b.clusterDescShort.toLowerCase();

          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        });

        f_clusters_topic.sort((a: any, b: any) => {
          let fa = a.ruimte.toLowerCase(),
            fb = b.ruimte.toLowerCase();

          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        });

        setDataClusterDesc(d_cluster_topic);
        setDataCluster(f_clusters_topic);

        const f_clusters_gemeente = f_clusters_topic.find((d: any) => {
          return parseInt(d.idRuimte) === parseInt(selectedGemeente.id);
        });

        const tmpGem =
          f_clusters_gemeente !== undefined
            ? d_cluster_topic.find(
                (d: any) =>
                  parseInt(f_clusters_gemeente.idCluster) === parseInt(d.id),
              )
            : {
                id: 0,
                clusterDescShort: 'niet van toepassing',
                clusterDesc: 'niet van toepassing',
                clusterNummer: 10,
              };
        setDataGemeente(tmpGem);

        const f_clusters_benchmark = f_clusters_topic.find((d: any) => {
          return parseInt(d.idRuimte) === parseInt(selectedBenchmarks[0].id);
        });

        const tmpBench =
          f_clusters_benchmark !== undefined
            ? d_cluster.find(
                (d: any) =>
                  parseInt(f_clusters_benchmark.idCluster) === parseInt(d.id),
              )
            : {
                id: 0,
                clusterDescShort: 'niet van toepassing',
                clusterDesc: 'niet van toepassing',
                clusterNummer: 10,
              };

        setDataBenchmark(tmpBench);
      }
    }
  }, [
    selectedGemeente,
    selectedBenchmarks,
    selectedTopic,
    d_ruimte,
    d_cluster,
    f_clusters,
  ]);

  const onChangeOnderwerpHandler = (event: any) => {
    setSelectedTopic(JSON.parse(event.target.value));
    setSelectedCluster(-1);
  };

  const onChangeClusterHandler = (event: any) => {
    setSelectedCluster(JSON.parse(event.target.value));
  };

  return (
    <Card className="card-borderless">
      <CardContent>
        <div
          className={'vl-typography'}
          style={{
            paddingLeft: '24px',
            paddingRight: '4px',
            marginBottom: '24px',
            marginRight: '16px',
          }}
        >
          <p className={'page-title-mobile'}>
            Welke gemeenten kennen gelijkaardige uitdagingen als{' '}
            {selectedGemeente.label}?
          </p>
          <p className={'page-subtitle-mobile'}>
            Per thema worden gemeenten met gelijkaardige kenmerken aan dezelfde
            cluster toegewezen (‘typologie van gemeenten’). Tot welke cluster
            behoort {selectedGemeente.label}?
          </p>{' '}
          <div
            className={'vl-typography'}
            style={{
              float: 'right',
              marginTop: '16px',
              marginBottom: '24px',
              marginRight: '24px',
              cursor: 'pointer',
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingRight: '8px',
              paddingLeft: '8px',
              backgroundColor: interfaceColor,
              borderRadius: 12,
              fontSize: mobile ? 13 : 'initial',
            }}
          >
            <p
              style={{
                color: 'white',
                textAlign: 'end',
                marginBottom: 0,
                fontSize: '11px',
              }}
              onClick={handleOpen}
            >
              Pas je selectie aan
            </p>
            <SelectionPanel
              open={open}
              setOpen={setOpen}
              themas={themas}
              indicatorThema={indicatorThema}
              gemeenteLijst={gemeenteLijst}
              selectedGemeente={selectedGemeente}
              selectedBenchmarks={selectedBenchmarks}
              benchmarkLijst={benchmarkLijst}
              setBenchmarkLijst={setBenchmarkLijst}
              d_ruimte={d_ruimte}
              isMobile={true}
            />
          </div>
          <div style={{ float: 'left' }}>
            <InfoPanelCluster
              mobile={true}
              content={
                <>
                  <p>
                    Bij een clusteranalyse wordt een typologie van gemeenten
                    opgemaakt. Gemeenten met gelijkaardige kenmerken worden
                    ondergebracht in homogene klassen.
                  </p>
                  <br />
                  <p>
                    De doelstelling van deze clusteranalyse per thema is om
                    lokale besturen meer inzicht te geven in alle beschikbare
                    data, en om zo de eigen lokale context beter te kunnen
                    beschrijven en analyseren. Daarnaast wordt het ook mogelijk
                    om meer inzicht te krijgen in deze context door te
                    vergelijken met andere gemeenten die een gelijkaardige
                    context kennen.
                  </p>
                  <br />
                  <p>
                    De typologie van gemeenten werd opgebouwd via een dubbele
                    statistische verwerking van de basisinformatie. Volgende
                    stappen kwamen aan bod:
                  </p>

                  <ul style={{ paddingLeft: 16 }}>
                    <li>1. Selectie van indicatoren.</li>
                    <li>
                      2. Factoranalyse: zorgt voor een reductie van het aantal
                      beginvariabelen en hergroepeert de informatie in een
                      kleiner aantal hoofdcomponenten voor het thema.
                    </li>
                    <li>
                      3. Clusteranalyse: groepeert de gemeenten met een zo
                      homogeen mogelijke omgeving binnen dit thema.
                    </li>
                    <li>
                      4. Interpretatie resultaten: beschrijft welke clusters we
                      per thema kunnen onderscheiden, en wat deze clusters
                      typeert.
                    </li>
                  </ul>
                </>
              }
              clusterAnalysePath={clusterAnalysePath}
            />
          </div>
          <hr style={{ clear: 'both', marginRight: '12px' }} />
        </div>
      </CardContent>
      <CardMedia style={{ width: '100%' }}>
        {d_cluster && f_clusters ? (
          <Grid container sx={{ maxHeight: '100%' }}>
            <Grid
              item
              xs={12}
              sx={{ paddingLeft: '36px', paddingRight: '32px' }}
            >
              <div
                className="vl-form-col--12-12"
                style={{ padding: '0.6rem', paddingRight: '16px' }}
              >
                <select
                  name="evolutieSelect"
                  className="vl-select vl-select--block"
                  tabIndex={0}
                  data-vl-select=""
                  data-vl-select-search-empty-text="Geen resultaten gevonden"
                  onChange={onChangeOnderwerpHandler}
                >
                  {d_thema.map((d: any, i: any) => {
                    if (d.thema !== 'Synthese' && d.thema !== 'Integratie') {
                      return (
                        <option
                          key={d.id}
                          value={JSON.stringify(d)}
                          selected={selectedTopic.id === d.id}
                        >
                          {d.thema.charAt(0).toUpperCase() +
                            d.thema.slice(1).toLowerCase()}
                        </option>
                      );
                    }
                  })}
                </select>
              </div>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                paddingLeft: '36px',
                paddingRight: '32px',
              }}
            >
              <div
                className="vl-form-col--12-12"
                style={{ padding: '0.6rem', paddingRight: '16px' }}
              >
                <select
                  name="evolutieSelect"
                  className="vl-select vl-select--block"
                  tabIndex={0}
                  data-vl-select=""
                  data-vl-select-search-empty-text="Geen resultaten gevonden"
                  onChange={onChangeClusterHandler}
                >
                  {clusterAlles
                    .concat(
                      d_cluster.filter(
                        (a: any) =>
                          a.idThema === selectedTopic.id &&
                          a.clusterDescShort !== 'Indicatoren',
                      ),
                    )
                    .sort((a: any, b: any) => {
                      if (!(a && a.clusterDescShort && b && b.clusterDescShort))
                        return;

                      const stringA = a.clusterDescShort.toUpperCase(); // ignore upper and lowercase
                      const stringB = b.clusterDescShort.toUpperCase(); // ignore upper and lowercase
                      if (stringA > stringB) return 1;
                      if (stringA < stringB) return -1;
                      return 0;
                    })
                    .map((d: any, i: any) => {
                      return (
                        <option
                          key={d.id}
                          value={d.id}
                          selected={selectedCluster === d.id}
                        >
                          {d.clusterDescShort}
                        </option>
                      );
                    })}
                </select>
              </div>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                paddingLeft: '36px',
                paddingRight: '36px',
                userSelect: 'none',
                fontSize: '0.8em',
                paddingTop: '16px',
                paddingBottom: '16px',
              }}
            >
              {clusterAlles
                .concat(d_cluster)
                .filter((a: any) => a.id === selectedCluster)
                .map((d: any) => {
                  return (
                    <div
                      style={{
                        margin: 'auto',
                        width: '100%',
                        textAlign: 'center',
                      }}
                    >
                      <p>{d.clusterDesc}</p>
                    </div>
                  );
                })}
            </Grid>

            <Grid item xs={0} lg={2}></Grid>
            <Grid
              item
              xs={12}
              lg={4}
              style={{
                textAlign: 'center',
                paddingBottom: '12px',
                fontSize: '14px',
              }}
            >
              {selectedGemeente.ruimte}: {dataGemeente.clusterDescShort}
              &nbsp;
              <span
                style={{
                  backgroundColor: dataCluster.find(
                    (d) => d.idRuimte === selectedGemeente.idRuimte,
                  )?.color,
                }}
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </Grid>
            <Grid
              item
              xs={12}
              lg={4}
              style={{
                textAlign: 'center',
                fontSize: '14px',
                paddingBottom: '12px',
              }}
            >
              {selectedBenchmarks[0].ruimte}: {dataBenchmark.clusterDescShort}
              &nbsp;
              <span
                style={{
                  backgroundColor: dataCluster.find(
                    (d) => d.idRuimte === selectedBenchmarks[0].idRuimte,
                  )?.color,
                }}
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </Grid>
            <Grid item xs={0} lg={2}></Grid>

            <Grid item xs={0} md={1} lg={2}></Grid>
            <Grid
              item
              xs={12}
              md={10}
              lg={8}
              sx={{
                maxHeight: '300px',
                paddingRight: '36px',
                paddingLeft: '32px',
                paddingBottom: '8px',
              }}
            >
              <MapVlaanderenInsights
                data={dataCluster}
                selectedCluster={selectedCluster}
                setSelectedCluster={setSelectedCluster}
              ></MapVlaanderenInsights>
            </Grid>
            <Grid item xs={0} md={1} lg={2}></Grid>

            <Grid
              item
              xs={12}
              lg={12}
              sx={{
                paddingLeft: '36px',
                paddingRight: '32px',
                paddingTop: '32px',
              }}
            >
              {clusterAlles
                .concat(d_cluster)
                .filter(
                  (a: any) =>
                    a.idThema === selectedTopic.id &&
                    a.clusterDescShort === 'Indicatoren',
                )
                .map((d: any) => {
                  return (
                    <div
                      style={{
                        height: '100%',
                        fontSize: 14,
                        margin: 'auto',
                        width: '100%',
                        textAlign: 'center',
                        border: '1px solid #ddd',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        padding: '8px',
                      }}
                    >
                      <p style={{}}>
                        Indicatoren gebruikt in de clusteranalyse:{' '}
                        {d.clusterDesc}
                      </p>
                    </div>
                  );
                })}
            </Grid>
          </Grid>
        ) : (
          <Grid container style={{ padding: '16px' }}>
            <Grid
              item
              xs={12}
              pl={5}
              pr={5}
              minHeight={'160px'}
              sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <p style={{ fontSize: '11px' }}>Geen data gevonden</p>
            </Grid>
          </Grid>
        )}
      </CardMedia>
    </Card>
  );
};
